<template>
  <div class="header-bar">
    Minecraft Manager
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="stylus" scoped>
  .header-bar
    height 48px
    width 100%
    background #324057
    line-height 48px
    color #F9FAFC
    text-align center
    border-bottom 1px solid #475669
</style>



// WEBPACK FOOTER //
// Left.vue?5f30b2fe